import { SurveysContext } from "@/context/SurveysContext";
import React from "react";

export default function useSurveys() {
  return React.useContext(SurveysContext);
}
